// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_sw-0";